import { useState } from "react";
import { motion } from "framer-motion";
import { Lock, GraduationCap, ArrowRight, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Passcode({ onLogin }) {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!value.trim()) return;
    setLoading(true);
    try {
      await api.post("/auth/verify", { passcode: value });
      toast.success("Welcome back, Ayaan!");
      onLogin();
    } catch (err) {
      toast.error("Incorrect passcode. Try again.");
      setValue("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center p-6 bg-gradient-to-br from-slate-50 via-indigo-50 to-purple-50 relative overflow-hidden">
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-indigo-200/40 rounded-full blur-3xl" />
      <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-purple-200/40 rounded-full blur-3xl" />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="relative w-full max-w-md bg-white rounded-3xl border border-slate-200 shadow-xl p-8 sm:p-10"
      >
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 rounded-2xl bg-indigo-600 flex items-center justify-center shadow-lg shadow-indigo-200">
            <GraduationCap className="w-6 h-6 text-white" />
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-indigo-500">Neev Academy · IB</p>
            <h1 className="text-2xl font-heading font-bold text-slate-900 leading-tight">AyaanKiStudies</h1>
          </div>
        </div>

        <h2 className="text-3xl font-heading font-bold text-slate-900 mb-2">Hey Ayaan 👋</h2>
        <p className="text-slate-500 mb-8">Enter your passcode to open your study hub.</p>

        <form onSubmit={submit} className="space-y-4">
          <div className="relative">
            <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            <Input
              data-testid="passcode-input"
              type="password"
              autoFocus
              placeholder="Enter passcode"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              className="h-14 pl-11 text-base rounded-xl border-slate-200 focus-visible:ring-indigo-500"
            />
          </div>
          <Button
            data-testid="passcode-submit"
            type="submit"
            disabled={loading}
            className="w-full h-14 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-base font-semibold transition-colors"
          >
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <>Enter Study Hub <ArrowRight className="w-4 h-4 ml-1" /></>}
          </Button>
        </form>
      </motion.div>
    </div>
  );
}
